import React from "react"
import { NoTableData, Table, TableContainer, Td, Th } from "~styled/table"
import LoadingTable from "~components/LoadingTable"
import SkeletonWrapper from "~components/SkeletonWrapper"
import { Redemption } from "~shapes/redemption"
import RedemptionRow from "~components/redemption/RedemptionRow"

export interface RedemptionProps {
  redemptions: Redemption[] | undefined
  isLoading: boolean
  fetchNextPage?: () => void
  hasNextPage?: boolean
  isFetchingNextPage?: boolean
}

const columns = [
  { id: "logo", label: "", width: "44px" },
  { id: "perk-title", label: "Perk", width: "auto" },
  { id: "redemption-date", label: "Date", width: "100px" },
  { id: "booking-number", label: "Booking #", width: "100px" },
  { id: "redemption-status", label: "Status", width: "120px" },
  { id: "obc", label: "OBC", width: "80px" },
  { id: "invalidation-reason", label: "Reason", width: "120px" },
  { id: "details", label: "Details", width: "140px" },
]

const UserRedemptionsList = ({
  redemptions,
  isLoading,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: RedemptionProps) => {
  const isFirstLoad: boolean = !redemptions && isLoading

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.currentTarget
    const bottom =
      target.scrollHeight - target.scrollTop <= target.clientHeight + 50
    if (bottom && fetchNextPage && hasNextPage && !isFetchingNextPage) {
      fetchNextPage()
    }
  }

  return (
    <TableContainer
      onScroll={handleScroll}
      style={{ maxHeight: "520px", overflowY: "auto" }}
    >
      <Table style={{ tableLayout: "auto" }}>
        <thead>
          <tr>
            {columns.map(col => (
              <Th
                $sticky
                key={col.id}
                style={{
                  width: col.width,
                  fontSize: 11,
                  fontWeight: 600,
                  textTransform: "uppercase" as const,
                  letterSpacing: "0.4px",
                  paddingBottom: 10,
                }}
              >
                {col.label}
              </Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isFirstLoad && (
            <LoadingTable rowHeight="50px" columns={8}>
              <Td>
                <SkeletonWrapper
                  isLoading={true}
                  className="skeleton-image"
                  width={32}
                />
              </Td>
            </LoadingTable>
          )}

          {!!redemptions &&
            redemptions.map((redemption: Redemption) => (
              <RedemptionRow
                key={redemption.id}
                redemption={redemption}
                isLoading={isLoading}
              />
            ))}
        </tbody>
      </Table>

      {!redemptions?.length && !isLoading && (
        <NoTableData style={{ fontSize: 13, color: "#7C8495" }}>
          No redemptions found.
        </NoTableData>
      )}
    </TableContainer>
  )
}
export default UserRedemptionsList
